import {memo} from 'react';

import * as styles from './style.module.scss';

const Placeholder = memo(function Placeholder({text}: {text: string}) {
  return <span className={styles.placeholder}>{text}</span>;
});

export {Placeholder};
